import { Container, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const BarriereMelden: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={2}>
					<Typography variant="h2" component={'h1'}>
                    Barriere melden
					</Typography>
					<Typography>Content Heir.</Typography>
				</Stack>
			</Container>
		</>
	);
};
export default BarriereMelden;
